<template>
    <div class="mx-8 mb-8">
        <cards/>
        <v-card class="elevation-0 py-4 px-8">
            <v-data-table
                :options.sync="options" 
                :footer-props="{'items-per-page-options':[15, 30, 50, meta.total]}"
                :server-items-length="meta.total"
                :headers="headers" 
                :items="tableItems"
                :loading="loader">
                <!-- Header -->
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Reporte de Costo de Inventario</v-toolbar-title>
                        <v-btn icon @click="openFilter()">
                            <v-badge overlap color="primary" :content="filtersLength" :value="filtersLength">
                                <v-icon>mdi-filter</v-icon>
                            </v-badge>
                        </v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.cost`]="{ item }">
                    {{(item.cost*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
                </template>
                <template v-slot:[`item.inventory_cost`]="{ item }">
                    {{(item.inventory_cost*1).toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}
                </template>
            </v-data-table>
        </v-card>
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="show_filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filters/>
        </v-navigation-drawer>
        <v-dialog v-model="filterMobile" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
            <filters @closeFilter="closeFilter"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import cards from "../cost_report/cards.vue"
import filters from "../cost_report/filter.vue"
export default {
    components:{
        cards:cards,
        filters:filters
    },
    data(){
        return{
            filterMobile:false,
            show_filters:false,
            headers:[
                { text: 'Producto', value: 'name' },
                { text: 'Costo', value: 'cost' },
                { text: 'Inventario', value: 'inventory' },
                { text: 'Costo de Inventario', value: 'inventory_cost' },
            ],
            dates:[],
            options: {
                page: 1,
                itemsPerPage: 15,
                sortBy: ['inventory'],
                sortDesc: [true],
            },
        }
    },
    watch: {
        options: {
            handler() {
                this.fetchData()
            },
            deep: true,
        },
    },
    methods:{
        openFilter(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = true
            }else{
                this.show_filters?(this.$emit("closeDrawer", true), this.show_filters = false):(this.$emit("closeDrawer", false), this.show_filters = true)
            }
        },
        closeFilter(){
            this.filterMobile = false
        },
        fetchData(){
            this.$store.dispatch('inventory_cost/getData', this.options)
        }
    },
    mounted() {
        this.fetchData()
    },
    computed: {
        tableItems(){
            return this.$store.state.inventory_cost.data
        },
        meta(){
            return this.$store.state.inventory_cost.meta
        },
        filtersLength(){
            return this.$store.state.inventory_cost.filters_length;
        },
        loader(){
            return this.$store.state.inventory_cost.loader
        },
    },
}
</script>
<style>
.v-data-table__progress th{
    display: table-cell;
    padding-bottom:5px!important;
}
</style>